import React, { FC } from 'react';
import clsx from 'clsx';
import styles from './PunchProgressBar.module.scss';
import { useTranslation } from 'react-i18next';

export const PUNCH_PROGRESS_BAR = {
  root: 'punch-progress-bar',
};

type PunchProgressBarProps = React.HTMLAttributes<HTMLElement> & {
  earnedStars: number;
  emptyStars: number;
  earnedStarImage: string;
  emptyStarImage: string;
}

export const PunchProgressBar : FC<PunchProgressBarProps> = ({ className, earnedStars, emptyStars, earnedStarImage, emptyStarImage }) => {
  const { t } = useTranslation();
  const total = earnedStars + emptyStars;

  return (
    <div role={'img'} aria-label={t('perks.punchProgress', { earned: earnedStars, total })} data-testid={PUNCH_PROGRESS_BAR.root} className={clsx(styles.container, className)}>
      {Array.from(Array(earnedStars).keys()).map((i) => <img key={i} alt={'punchEarned'} className={styles.star} src={earnedStarImage} />)}
      {Array.from(Array(emptyStars).keys()).map((i) => <img key={i} alt={'punchRequired'} className={styles.star} src={emptyStarImage} />)}
    </div>
  );

};
